import { BusinessType, NumberOfEmployees } from "../Dto/StaticData";

export const NumberOfEmployeesDictionary: NumberOfEmployees[] = [
    {Name:"1 to 49", Id:1},
    {Name:"50 to 149", Id:2},
    {Name:"150 or more", Id:3}
]

export const BusinessTypeDictionary: BusinessType[] = [
    {Name:"Private Sector", Id:1},
    {Name:"National Government", Id:2},
    {Name:"Local Government", Id:3},
    {Name:"Non-profit Organisation", Id:4},
    {Name:"State-Owned Enterprise", Id:5},
    {Name:"Provincial Government", Id:6},
    {Name:"Educational Institution", Id:7}
]